import React from 'react'
import PropTypes from 'prop-types'
import { SetInitialConstraints } from '@morningtrain/react-filters'
import { Resources } from '@morningtrain/resources'
import useOperation from './hooks/use-operation'
import useModel from './hooks/use-model'
import { getMapValue } from '@morningtrain/react-helpers'
import ModelProxyPayload from './ModelProxyPayload'
import ConstrainableOperation from './constraining/ConstrainableOperation'

function ModelProxy (props) {
  const parentOperation = useOperation()
  const parentModel = useModel()

  const [id, setId] = React.useState(props.id)

  React.useEffect(() => {
    if (props.id !== id) {
      setId(props.id)
    }
  })

  function resourceName () {
    if (!props.resourceName && parentOperation) {
      return parentOperation.resource.slug
    }

    return props.resourceName
  }

  function operation () {
    return Resources.make(props.namespace, resourceName())
      .operation(props.operationName)
  }

  function initialContraints () {
    const constraints = {}

    if (parentModel && parentOperation) {
      constraints[parentOperation.parameterKey] = getMapValue(parentModel, parentOperation.modelKey)
    } else if (id) {
      constraints[operation().parameterKey] = id
    }

    return constraints
  }

  function operationContext () {
    if (props.clean === true) {
      return props.operationContext
    }

    const context = { ...initialContraints() }

    return context
  }

  const operationProps = {
    namespace: props.namespace,
    resourceName: resourceName(),
    operationName: props.operationName,
    proxy: true,
    operationContext: operationContext(),
    persist: props.persist,
    provideErrors: props.provideErrors
  }

  return (
    <ConstrainableOperation {...operationProps}>
      <SetInitialConstraints constraints={initialContraints()} />
      <ModelProxyPayload proxyFrom={props.proxyFrom}>
        {props.children}
      </ModelProxyPayload>
    </ConstrainableOperation>
  )
}

ModelProxy.defaultProps = {
  namespace: 'api',
  operationName: 'read',
  operationContext: {},
  proxyFrom: null,
  persist: false,
  clean: false,
  provideErrors: true
}

ModelProxy.propTypes = {
  namespace: PropTypes.string,
  operationName: PropTypes.string,
  operationContext: PropTypes.any,
  proxyFrom: PropTypes.any,
  persist: PropTypes.bool,
  clean: PropTypes.bool,
  provideErrors: PropTypes.bool
}

export default ModelProxy
